// extracted by mini-css-extract-plugin
export default {"wrapper":"w9","container":"x9","title":"y9","desc":"z9","usage":"A9","box":"B9","subtitle":"C9","ingredients":"E9","carousel":"F9","ingredientscarousel":"G9","productinfo":"H9","ingredientsinfo":"I9"};
    if(module.hot) {
      // 1711717535625
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  